import { Button, makeStyles, Text, tokens } from '@fluentui/react-components';
import { ErrorCircleRegular } from '@fluentui/react-icons';

import { spacing, statusPalette } from '@/theme/tokens';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: spacing.xxxxl,
    gap: spacing.s,
    textAlign: 'center',
  },
  icon: {
    width: '48px',
    height: '48px',
  },
});

interface ErrorStateProps {
  title?: string;
  description?: string;
  retry?: () => void;
}

export function ErrorState({ title = 'Something went wrong', description, retry }: ErrorStateProps) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <ErrorCircleRegular className={classes.icon} style={{ color: statusPalette.unhealthy }} />
      <Text size={500} weight="semibold" style={{ color: tokens.colorNeutralForeground1 }}>
        {title}
      </Text>
      {description ? (
        <Text size={300} style={{ color: tokens.colorNeutralForeground3, maxWidth: '480px' }}>
          {description}
        </Text>
      ) : null}
      {retry ? (
        <Button appearance="secondary" onClick={retry}>
          Try again
        </Button>
      ) : null}
    </div>
  );
}
